/* NOREGRETS PDP — shared scroll reveal.
   Opt-in from JS: elements start visible in markup and are only hidden once
   we know we can reveal them again. A dead observer can never swallow content. */
(function () {
  if (window.__nrBrutalReveal) return;
  window.__nrBrutalReveal = true;

  function init() {
    var targets = document.querySelectorAll('[data-nr-reveal]');
    if (!targets.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el, i) {
      el.classList.add('nr-reveal');
      el.style.transitionDelay = (i % 4) * 60 + 'ms';
      io.observe(el);
      // Safety net: if the observer never fires, show it anyway.
      setTimeout(function () { el.classList.add('in'); }, 2500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
